export default __webpack_public_path__ + "static/homepage-spa-e50a8438fc90f0ecd114b7c45333fb5a.jpg";